import { Ellipsis } from "antd-mobile";
import React from "react";

import styles from "./style.module.scss";

function ListItem({ title = "", contentRender = () => {}, date = "", onClick = () => {} }) {
  return (
    <div className={styles.listItem} onClick={onClick}>
      <Ellipsis
        direction="end"
        content={title}
        style={{
          color: "var(--notufy-list-title)",
          fontSize: "var(--fontSetting-normal)",
          fontWeight: 400,
        }}
      />
      <div className={styles.content}>{contentRender()}</div>
      <div className={styles.date}>{date}</div>
    </div>
  );
}

export default ListItem;
